import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface SmartCaConfig {
  enabled: boolean;
  username: string;
  environment: 'production' | 'uat';
  fullName: string;
  serialNumber: string;
  issuer: string;
  validTo: string;
  lastConnectedAt?: string;
}

interface SmartCaState {
  config: SmartCaConfig | null;
  saveConfig: (cfg: SmartCaConfig) => void;
  removeConfig: () => void;
}

export const useSmartCaStore = create<SmartCaState>()(
  persist(
    (set) => ({
      config: null,
      saveConfig: (config) => set({ config }),
      removeConfig: () => set({ config: null }),
    }),
    {
      name: 'pdfsign-smartca',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
